
import React from 'react';

import AuthenticationService from '../../backend/AuthenticationService';
import { translate } from "react-i18next";
import {  Button, Card, ListGroup, ListGroupItem } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../App.css';
import {BLUE_BG} from "../../backend/Colors";



class CreatePublicEventWidget extends React.Component {

    render() {
        const { t } = this.props;
        let user = AuthenticationService.getLoggedUser();
        return (
            <Card  className="ml-2 mb-2" >
                <Card.Header style={{"backgroundColor": BLUE_BG}} ><i className="text-primary fa fa-user s24  ml-2 mr-1 " >&nbsp;</i>{ t("myPublicEvents") }</Card.Header>
                <Card.Body className="pt-0 pb-0">
                    <ListGroup className="list-group-flush">
                        <ListGroupItem><Link to={!user ? `/loginPage/search`: `/myPublicEvent/${user.id}`}  >{t("myPublicEvents")}</Link></ListGroupItem>
                        <ListGroupItem><Link to={!user ? `/loginPage/search`:`/booked/${user.id}`}  >{t("myBookings")}</Link></ListGroupItem>
                        <ListGroupItem><Link to={!user ? `/loginPage/search`:`/favorites/${user.id}`}  >{t("Favorites")}</Link></ListGroupItem>
                        <ListGroupItem><Link to={!user ? `/loginPage/search`:`/subscriptions/${user.id}`}  >{t("Abos")}</Link></ListGroupItem>
                    </ListGroup>
                </Card.Body>
                <Card.Footer>
                <Link to={!user ? `/loginPage/pubEventAdd`: `/pubEventAdd`  }   >
                                <Button variant="primary" block size="sm" >
                                <i  className="fa fa-plus mr-1"></i>{t("CreatePublicEvent")}
                                </Button></Link>
                    </Card.Footer>
            </Card>);
    }
}

export default translate("translations")(CreatePublicEventWidget);
